export const environment = {
    production: true,
    api_base_url: '/api',
    base_url: 'https://gaia-preprod.a2l.net',
    client_version: '2.9.26-2.staging',
    style: 'dev'
};
